import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  CombosConfiguration,
  enumActions,
  FunctionsService,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { GeneratePdfFosilService } from 'app/services/generate-pdf-fosil.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { WorkOrderService } from 'app/services/work-order.service';
import { NotificationsService } from 'app/services/notifications.service';
import { ResourcesService } from 'app/services/resources.service';
import { Location } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { IButtonIcon } from 'brainloper-ui';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { ModalMaintenanceOrdersComponent } from '../modal-maintenace-orders/modal-maintenace-orders.component';
import { IRegisterMaintenance } from 'app/models2/maintenance/register-maintenance';
import { SizePicture } from 'app/models2/commos/size-pircture';
import { Equipment } from 'app/models2/maintenance/equipment';
import { ComponentEquipment } from 'app/models2/maintenance/component';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { Data, DataResouce } from 'app/models2/commos/base-response-data';
import { UserWO } from 'app/models2/administration/user-WO';
import { Activity } from 'app/models2/maintenance/activity';
import { Provider } from 'app/models2/administration/provider';
import { User } from 'app/models2/administration/user';
import { Resources } from 'app/models2/maintenance/resources';
import { dataWO } from 'app/models2/maintenance/data-wo';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { HistoryInventory } from 'app/models2/inventory/history-inventory';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { UpdateData } from 'app/models2/commos/update-data';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ItemComboLength } from 'app/models2/inventory/item-combo-length';
import { Item } from 'app/models2/inventory/item';
import { enumProviderType } from 'app/models2/commos/enum-provider-type';
import {
  ITypeMaintenance,
  TypeMaintenance,
} from '@edgarzon93/brainloper-shared/dist/interfaces/ITypeMaintenance';
import { CommentDto } from 'app/models2/maintenance/comment';
import { CommentService } from 'app/services/comment.service';
import { DeviceService } from 'app/services/device.service';

@Component({
  selector: 'app-maintenace-order-detail',
  templateUrl: './maintenace-order-detail.component.html',
  styleUrls: ['./maintenace-order-detail.component.scss'],
})
export class MaintenaceOrderDetailComponent implements OnInit, OnDestroy {
  @Input() registerMaintenance: boolean = false;
  @Output() registerMaintenanceEvent = new EventEmitter<IRegisterMaintenance>();

  @ViewChild('stepper') stepper: MatStepper;

  public EndpointDictionary = EndpointDictionary;
  public urlTablaEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`;
  private urlGetDetalleEquipos: string = `${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`;
  public urlGetTablaActividades: string = `${EndpointDictionary.Activity.ACTIVITY_TABLE}`;
  private urlGetDetalleActividad: string = `${EndpointDictionary.Activity.CRUD_ACTIVITY_DATA}`;
  private urlActividadEmergente: string = `${EndpointDictionary.ActivityeEmerg.CRUD_ACTIVITY_EMERG_DATA}`;
  private urlPostOT: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`;
  private urlPostUsuariosOT: string = `${EndpointDictionary.UserOrder.CRUD_USER_ORDER_DATA}`;
  private urlComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`;
  public urlGetTablaTerceros: string = `${EndpointDictionary.Provider.PROVIDER_TABLE}`;
  public urlGetTablaUsuarios: string = `${EndpointDictionary.User.USER_TABLE}`;
  public urlGetTablaUsuariosOrdenes: string = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`;
  public urlGetCrudResources: string = `${EndpointDictionary.Resources.CRUD_RESOURCES_DATA}`;
  public urlGetTablaResources: string = `${EndpointDictionary.Resources.RESOURCES_TABLE}`;
  public urlGetTablaResourcesRequest: string = `${EndpointDictionary.ResourcesRequest.RESOURCES_REQUEST_TABLE}`;
  private urlGetComboResourcesRequest: string = `${EndpointDictionary.ResourcesRequest.RESOURCES_REQUEST_COMBO}`;
  private urlGetComboResourcesActivity: string = `${EndpointDictionary.ResourcesActivity.RESOURCES_ACTIVITY_COMBO}`;
  public urlGetItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;

  public companyId = this.storage.get<number>('companyId');
  private resourceByRequest: Item[] = [];
  public typeMaintenance = new TypeMaintenance();
  public buttonstypeOfMaintenance: ITypeMaintenance[] = [];
  public buttonResponsible: IButtonIcon[] = [
    {
      id: 'usuario',
      icon: 'users',
      color: '#4232d1',
      name: 'Usuario',
      description: '',
      active: true,
    },
    {
      id: 'tercero',
      icon: 'user-secret',
      color: '#09f1f1',
      name: 'Tercero',
      description: '',
      active: true,
    },
  ];

  public userId = this.storage.get<number>('cedula');

  public params: params[] = [];
  public paramsTerceros: params[] = [
    { id: 'providerTypeId', value: enumProviderType.MATENIMIENTO },
  ];
  public paramsActividades: params[] = [{ id: 'equipmentId', value: 0 }];
  public paramsUsuariosOrdenes: params[] = [{ id: 'orderId', value: '0' }];
  public paramsResources: params[] = [{ id: 'orderId', value: '0' }];
  public paramsComments: params[] = [{ id: 'orderId', value: '0' }];
  //private paramsNotification: params [] = [{ id: 'id_compania', value: this.storage.get<number>('userId') }]

  public sizePicture: SizePicture;
  public imageSrc: string = '';
  public equipo: Equipment = {};
  public componentes: ComponentEquipment[];
  public isMobile;
  public actividad = {
    body: [],
    label: '',
  };
  private orderId: number;
  public data: dataWO = this.session.getData('data');
  //private resoruces : HistoryInventory = null
  public resources: Array<InputOrOutputInventory> = [];
  private size: number = 90;
  public inventoryModule: boolean =
    this.storage.get<boolean>('inventory_module');

  public isChecked: boolean = true;
  public labelToggle: string = 'Tabla Usuarios';
  public bodyResponsable = [];
  public buttonActive: boolean = false;
  public buttonEnd: boolean = false;

  //chip responsable
  public visible: boolean = true;
  public selectable: boolean = true;
  public removable: boolean = true;
  public chipResponsable: params[] = [];

  //tabla equipos
  public recargarTablaEquipos = new EventEmitter<any>();
  public dataEquipos: Equipment[] = [];
  public configurationEquipos: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };
  public columnasEquipos: TableColumns<Equipment>[] = [
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
  ];

  //tabla actividades
  public titleActividades: string = 'Actividades';
  public recargarTablaActividades = new EventEmitter<any>();
  public configurationActividades: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };
  public columnasActividades: TableColumns<Activity>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'componentName',
      label: 'Componente',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'odometerFrequency',
      label: 'Frecuencia odómetro/horómetro',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'timeFrequency',
      label: 'Frecuencia tiempo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'resources',
      label: 'Recursos',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  //tabla terceros
  public titleTerceros: string;
  public recargarTablaTerceros = new EventEmitter<any>();
  public dataTerceros: Provider[] = [];
  public configurationTerceros: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };
  public columnasTerceros: TableColumns<Provider>[] = [
    {
      ID: 'providerName',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'companyPhone',
      label: 'Telefono',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'city',
      label: 'Ciudad',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'address',
      label: 'Direccion',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
          ID: 'email',
          label: 'Email',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
    },
  ];

  //tabla usuarios
  public titleUsuarios: string;
  public recargarTablaUsuarios = new EventEmitter<any>();
  public configurationUsuarios: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'userId',
  };
  public columnasUsuarios: TableColumns<User>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'jobTitle',
      label: 'Cargo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'area',
      label: 'Area',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  //tabla usuarios ordenes
  public titleUsuariosOrden: string;
  public recargarTablaUsuariosOrden = new EventEmitter<any>();
  public configurationUsuariosOrden: TableConfiguration = {
    edit: false,
    add: true,
    delete: true,
    selectable: true,
    addPer: true,
    primaryKey: 'id',
  };
  public columnasUsuariosOrden: TableColumns<UserWO>[] = [];

  //Tabla Recursos

  public reloadResouces = new EventEmitter<any>();
  public configurationResouces: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable: true,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
    print: false,
  };

  public columnsResouces: TableColumns<Resources>[] = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'itemName',
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
        returnDataSelect: true,
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Item',
      disregardForAdd: true,
      disregardForEdit: true,
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Item',
      disregardForAdd: true,
      disregardForEdit: true,
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
  ];

  //Tabla Comentarios
  public titleC: string = screen.width > 400 ? 'Comentarios OT' : ''
  public reloadComments = new EventEmitter<any>();
  public configurationComments: TableConfiguration = {
    edit: true,
    add: true,
    delete: false,
    selectable: false,
    primaryKey: 'id',
    addPer: true,
    editPer: true,
  };

  public columnsComments: TableColumns<CommentDto>[] = [
    {
      ID: 'comment',
      label: 'Comentario',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'attachmentUrl',
      label: 'Archivo Adjunto',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      rules: [
        {
          action: enumActions.SHOW_FILE_ICON,
        },
      ],
    },
    {
      ID: 'createdBy',
      label: 'Creado por',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  public formStepeOne: UntypedFormGroup;
  public formStepeTwo: UntypedFormGroup;
  public validateResoruces: UntypedFormGroup;
  public formOT: UntypedFormGroup;
  public formStepeFour: UntypedFormGroup;
  public screen: boolean = true;

  public reloadComboauthorize = new EventEmitter<any>();
  public combosConfigauthorize: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlComboUsuarios,
    urlParams: [],
    label: 'Autoriza',
    selected: 0,
  };

  public reloadComboResponsable = new EventEmitter<any>();
  public combosConfigResponsable: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlComboUsuarios,
    urlParams: [],
    label: 'Responsable',
  };

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Orden de trabajo',
      router: '/mantenimiento/orden_trabajo',
    },
    {
      name: 'Detalle',
      current: true,
    },
  ];

  public itemsDataRequest: Array<InputOrOutputInventory> = [];
  public comboItemLength: number = 1;
  public haveResources: boolean = false;
  private idActivity: number;
  private lastExecutionDate: string;

  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private generatePdf: GeneratePdfFosilService,
    public deleteItem: DeleteGenericService,
    public workOrderService: WorkOrderService,
    public notificationService: NotificationsService,
    private storage: LocalStorageService,
    private resourcesService: ResourcesService,
    private location: Location,
    private commentService: CommentService,
    private deviceService: DeviceService,
  ) {
    if (!this.data) this.router.navigate(['inicio']);

    (this.formStepeOne = this.formBuilder.group({
      equipmentId: '',
    })),
      (this.formStepeTwo = this.formBuilder.group({
        tipoMtto: '',
      })),
      (this.formOT = this.formBuilder.group({
        responsibleId: '',
        executionDate: '',
        description: '',
        componentId: '',
        estimatedTime: '',
        resources: '',
        authorizesId: '',
        cost: '0',
        currentOdometer: '',
        invoiceReference: '',
      })),
      (this.formStepeFour = this.formBuilder.group({
        responsibleType: '',
      }));

    this.validateResoruces = this.formBuilder.group({
      resorucesAdd: null,
    });
  }

  async ngOnInit() {
    this.message.openLoading('Cargando', 'Cargando información');

    if (this.registerMaintenance) {
      this.inventoryModule = false;
    }
    this.handlerScreen();

    this.isMobile = this.deviceService.isMobile();
    this.size = screen.height > 830 ? 70 : this.size;
    this.picture();

    await this.combos();
    this.setAuthorize(this.userId);

    switch (this.data.action) {
      case 'edit':
        this.canNotEditResources();
        await this.startFields();
        break;
      case 'calendario':
        await this.calendario();
        break;
      case 'solicitud':
        await this.solicitud();
        break;
    }
    this.message.closeLoading();
  }

  ngOnDestroy() {
    this.session.setData('data', null);
  }

  private handlerScreen() {
    if (window.screen.width > 1000) {
      this.screen = true;
      window.addEventListener('resize', () => {
        window.screen.width > 1000
          ? (this.screen = true)
          : (this.screen = false);
      });
    } else {
      this.screen = false;
      window.addEventListener('resize', () => {
        window.screen.width > 1000
          ? (this.screen = true)
          : (this.screen = false);
      });
    }
  }

  canNotEditResources() {
    if (
      this.data.body[0].authorized == 1 &&
      this.data.body[0].readyResources == 1
    ) {
      this.configurationResouces.edit = false;
      this.configurationResouces.add = false;
      this.configurationResouces.delete = false;
      this.configurationResouces.selectable = false;
    }
  }

  async solicitud() {
    var executionDate = `${this.data.body.date}T08:00:00.000Z`;
    await this.clickRowEquipment({ id: this.data.body.equipmentId });
    this.formOT.controls.description.setValue(this.data.body.description);
    this.formOT.controls.resources.setValue(this.data.body.resources);
    this.formOT.controls.cost.setValue(this.data.body.cost);
    this.formOT.controls.executionDate.setValue(executionDate);
    this.typeOfMaintenance(this.data.body.maintenanceType, false);
    this.setResponsible(this.data.body.requests);
    this.actividad.label = 'Formulario';
    await this.getResourcesRequestOrCalendar();
    this.message.closeLoading();
  }

  async getResourcesRequestOrCalendar() {
    let paramsResources: params[] = [];
    let url = '';
    if (this.data.action == 'solicitud') {
      url = this.urlGetComboResourcesRequest;
      paramsResources.push({ id: 'requestId', value: this.data.body.id });
    }
    if (this.data.action == 'calendario') {
      url = this.urlGetComboResourcesActivity;
      paramsResources.push({ id: 'activityId', value: this.data.body.id });
    }
    if (this.data.action == 'add') {
      url = this.urlGetComboResourcesActivity;
      paramsResources.push({ id: 'activityId', value: this.idActivity });
    }
    let resResources: Array<InputOrOutputInventory> =
      await this.http.getDataBody(url, paramsResources);
    if (resResources) {
      this.resources = resResources;
    }
    //
  }

  async dataResources($event: DataResouce<Resources[]>) {
    this.resourceByRequest = $event.data;
    if ($event.data.length == 0) this.haveResources = false;
    else this.haveResources = true;
  }

  private async calendario() {
    let id_equipo = { id: this.data.body.equipmentId };
    await this.clickRowEquipment(id_equipo);
    let id_actividad = { id: this.data.body.id };
    await this.clickFilaActividades(id_actividad);
    this.typeOfMaintenance('preventivo', false);
    this.setResponsible(this.data.responsibleId);
    await this.getResourcesRequestOrCalendar();
  }

  setAuthorize(value: number) {
    this.formOT.controls.authorizesId.setValue(value);
    this.combosConfigauthorize.selected = value;
    this.reloadComboauthorize.emit('selected');
  }

  setResponsible(value: number) {
    this.formOT.controls.responsibleId.setValue(value);
    this.combosConfigResponsable.selected = value;
    this.reloadComboResponsable.emit('selected');
  }

  async startFields() {
    this.formStepeTwo.controls.tipoMtto.setValue(
      this.data.body[0].maintenanceType
    );
    this.paramsUsuariosOrdenes = [
      { id: 'orderId', value: this.data.body[0].id },
    ];
    this.paramsResources = [{ id: 'orderId', value: this.data.body[0].id }];
    this.paramsComments = [{ id: 'orderId', value: this.data.body[0].id }];
    this.haveResources = true;
    await this.clickRowEquipment({ id: this.data.body[0].equipmentId });
    this.bodyResponsable = this.data.body[0].userWO;
    this.changeToggle({ source: null, checked: false });
    this.reloadResouces.emit();
    this.reloadComments.emit();
    this.typeResponsibleView();
    for (let controls of Object.keys(this.formOT.controls)) {
      if (this.data.body[0][controls]) {
        this.formOT.controls[controls].setValue(this.data.body[0][controls]);
      }
    }

    if (this.data.body[0].cost == 'null') {
      this.formOT.controls.cost.setValue('0');
    }

    if (this.data.body[0].componentId == 0) {
      this.formOT.controls.componentId.setValue(0);
    }
    let fecha = this.functionEter.dateIso(this.data.body[0].executionDate);
    this.formOT.controls.executionDate.setValue(`${fecha}T08:00:00.000Z`);
    this.message.closeLoading();
  }

  typeResponsibleView() {
    if (this.data.body.responsible == 'tercero') {
      this.columnasUsuariosOrden = [
        {
          ID: 'name',
          label: 'Nombre',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
        {
          ID: 'companyPhone',
          label: 'Telefono',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
        {
          ID: 'providerCity',
          label: 'Ciudad',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
        {
          ID: 'providerAddress',
          label: 'Direccion',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
        },
        {
          ID: 'email',
          label: 'Email',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
        },
      ];
    } else {
      this.columnasUsuariosOrden = [
        {
          ID: 'userId',
          label: 'Cedula',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
        {
          ID: 'name',
          label: 'Nombre',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
        {
          ID: 'jobTitle',
          label: 'Cargo',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
        },
        {
          ID: 'area',
          label: 'Area',
          type: 'text',
          style: {
            textAlign: 'center',
            movil: 'no-movil',
          },
        },
        {
          ID: 'phone',
          label: 'Telefono',
          type: 'text',
          style: {
            textAlign: 'center',
          },
        },
      ];
    }
    this.recargarTablaUsuariosOrden.emit();
  }

  async combos() {
    this.buttonstypeOfMaintenance =
      await this.workOrderService.getTypeOfMaintenance();
  }

  picture() {
    let sizeW = ((screen.height + screen.width) / 2) * 0.2;
    let sizeH = ((screen.height + screen.width) / 2) * 0.15;
    this.sizePicture = {
      width: `${sizeW}px`,
      height: `${sizeH}px`,
      margin: '3px',
      visibility: 'hidde',
    };
  }

  async clickRowEquipment($event: Equipment) {
    let res: Equipment[] = await this.http.getDataBody(
      `${this.urlGetDetalleEquipos}/${$event.id}`
    );
    if (res) {
      this.equipo = res[0];
    }
    if (this.equipo.photo == '') {
      this.imageSrc = 'Falta Imagen';
    }
    this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${this.equipo.photo}/${this.companyId}`;
    this.sizePicture.visibility = 'visible';
    this.componentes = this.equipo.components;
    this.equipo.components.unshift({ id: 0, name: this.equipo.code });
    if (this.componentes.length == 1) {
      this.formOT.controls.componentId.setValue(0);
    }
    this.formStepeOne.controls.equipmentId.setValue(this.equipo.id);
    this.formOT.controls.currentOdometer.setValue(this.equipo.currentOdometer);
    this.setResponsible(this.equipo.userId);
    this.typeMaintenance = new TypeMaintenance();
  }

  async typeOfMaintenance($event: string, stepperNext: boolean = true) {
    this.typeMaintenance = this.buttonstypeOfMaintenance.find(
      (x) => x.id == $event
    );
    if (!this.typeMaintenance) return;
    if (this.typeMaintenance.loadPreventiveMaintenance) {
      var p = this.paramsActividades.find((x) => x.id == 'equipmentId');
      //   console.log(p, this.equipo.id)
      if (!p || p.value != this.equipo.id) {
        this.paramsActividades = [{ id: 'equipmentId', value: this.equipo.id }];
        this.recargarTablaActividades.emit();
      }
    } else {
      //this.paramsActividades = [];
    }

    this.formStepeTwo.controls.tipoMtto.setValue($event);
    this.setResponsible(this.equipo.userId);
    this.reloadComboResponsable.emit('selected');
    if (stepperNext) this.stepper.next();
  }

  async clickFilaActividades($event: Activity) {
    this.message.openLoading('Cargando', 'Obteniendo información');
    this.idActivity = $event.id;

    let res: Array<Activity> = await this.http.getDataBody(
      `${this.urlGetDetalleActividad}/${this.idActivity}`
    );
    await this.getResourcesRequestOrCalendar();
    if (res) {
      this.actividad.body = res;
      for (let controls of Object.keys(this.formOT.controls)) {
        if (this.actividad.body[0][controls]) {
          this.formOT.controls[controls].setValue(
            this.actividad.body[0][controls].toString()
          );
        }
      }
      //this.formOT.controls.executionDate.setValue(this.functionEter.dateIso(this.data.body[0]['executionDate']))
      this.actividad.label = 'Formulario preventivo';
    }
    this.message.closeLoading();
  }

  jumpSelectActivity() {
    this.actividad.label = 'Formulario';
  }

  checkDateRange($event: string) {
    const newDate = new Date($event);
    newDate.setUTCHours(0, 0, 0, 0);
    const lastDate = new Date(this.lastExecutionDate);
    lastDate.setUTCHours(0, 0, 0, 0);

    if (newDate.getTime() === lastDate.getTime()) {
      return;
    }

    this.lastExecutionDate = newDate.toISOString();
    this.lastExecutionDate = $event;

    let mesH;
    let mesUser;
    let hoy = new Date();
    let date = new Date($event);
    let year = hoy.getFullYear() - date.getFullYear();
    let month = date.getMonth() - hoy.getMonth();
    let day = date.getDate() - hoy.getDate();

    switch (hoy.getMonth()) {
      case 0:
        mesH = 'Enero';
        break;
      case 1:
        mesH = 'Febrero';
        break;
      case 2:
        mesH = 'Marzo';
        break;
      case 3:
        mesH = 'Abril';
        break;
      case 4:
        mesH = 'Mayo';
        break;
      case 5:
        mesH = 'Junio';
        break;
      case 6:
        mesH = 'Julio';
        break;
      case 7:
        mesH = 'Agosto';
        break;
      case 8:
        mesH = 'Septiembre';
        break;
      case 9:
        mesH = 'Octubre';
        break;
      case 10:
        mesH = 'Noviembre';
        break;
      case 11:
        mesH = 'Diciembre';
        break;
      default:
        break;
    }
    switch (date.getMonth()) {
      case 0:
        mesUser = 'Enero';
        break;
      case 1:
        mesUser = 'Febrero';
        break;
      case 2:
        mesUser = 'Marzo';
        break;
      case 3:
        mesUser = 'Abril';
        break;
      case 4:
        mesUser = 'Mayo';
        break;
      case 5:
        mesUser = 'Junio';
        break;
      case 6:
        mesUser = 'Julio';
        break;
      case 7:
        mesUser = 'Agosto';
        break;
      case 8:
        mesUser = 'Septiembre';
        break;
      case 9:
        mesUser = 'Octubre';
        break;
      case 10:
        mesUser = 'Noviembre';
        break;
      case 11:
        mesUser = 'Diciembre';
        break;
      default:
        break;
    }

    if (year != 0) {
      if (year == -1 && hoy.getMonth() == 11) {
        console.log(
          `Mantenimiento programada para el año ${date.getFullYear()}`
        );
      } else {
        this.message.Warning(
          'Advertencia',
          `Estamos en el año ${hoy.getFullYear()} y la fecha de mantenimiento que está programada está para el año ${date.getFullYear()}`
        );
      }
    } else {
      if (month > 0) {
        if (month == 1) {
          day = Math.abs(hoy.getDate() - date.getDate() - 30);
          //console.log("dia",day)
          if (day > 15) {
            this.message.Warning(
              'Advertencia',
              `Estamos en el mes ${mesH} y estás programando el mantenimiento para el mes ${mesUser}`
            );
          }
        } else {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando el mantenimiento para el mes ${mesUser}`
          );
        }
      } else {
        if (month < 0) {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando el mantenimiento para el mes ${mesUser} que ya pasó`
          );
        }
      }
    }
  }

  async getOtFromForm(): Promise<WorkOrder> {
    return {
      responsibleId: this.formOT.controls.responsibleId.value,
      executionDate: this.functionEter.dateForm(
        this.formOT.controls.executionDate.value
      ),
      description: this.formOT.controls.description.value,
      equipmentId: this.equipo.id,
      componentId: this.formOT.controls.componentId.value,
      creatorId: this.userId,
      estimatedTime: this.formOT.controls.estimatedTime.value,
      maintenanceType: this.formStepeTwo.controls.tipoMtto.value,
      resources: this.formOT.controls.resources.value,
      active: 1,
      authorizesId: this.formOT.controls.authorizesId.value,
      cost: this.formOT.controls.cost.value,
      currentOdometer: this.formOT.controls.currentOdometer.value,
      invoiceReference: this.formOT.controls.invoiceReference.value,
      authorized:
        this.formOT.controls.authorizesId.value == this.userId ? 1 : 0,
      readyResources: !this.inventoryModule
        ? 1
        : this.resources.length > 0
        ? 0
        : 1,
    };
  }

  async saveResourcesInMemory($event: HistoryInventory) {
    this.validateResoruces.controls.resorucesAdd.setValue(true);
    this.resources = $event.items;
    this.stepper.next();
  }

  comboItemsLength($event: ItemComboLength) {
    this.comboItemLength = $event.length;
  }

  async deleteResources($event: Array<Resources>) {
    await this.deleteItem.deleteD(
      $event,
      this.urlGetCrudResources,
      'id',
      'Recurso',
      'Recursos'
    );
    this.reloadResouces.emit();
  }

  async addResources($event: Resources) {
    if (
      this.resourceByRequest.find(
        (x) => x.itemInventoryId.toString() == $event.itemName
      )
    ) {
      this.message.Warning('Advertencia', 'Item ya seleccionado');
      return;
    }
    $event.itemId = parseInt($event.itemName);
    await this.resourcesService.addResourcesFromTable(
      $event,
      this.data.body[0].id,
      true
    );
    this.reloadResouces.emit();
  }

  async editResources($event: UpdateData<Resources>) {
    await this.resourcesService.editResourcesFromTable(
      $event,
      this.data.body[0].id,
      true
    );
    this.reloadResouces.emit();
  }

  async deleteComments($event: Array<CommentDto>) {
    await this.deleteItem.deleteD(
      $event,
      EndpointDictionary.WorkOrder.COMMENTS.CRUD_DATA,
      'id',
      'Comentario',
      'Comentarios'
    );
    this.reloadComments.emit();
  }

  async addComments($event: number) {
    this.commentService.addComment(this.data.body[0].id, () => {
      this.reloadComments.emit();
    });
  }

  async editComments($event: CommentDto) {
    if ($event[0].createdById != this.userId) {
      this.message.Error(
        'Acción no permitida',
        'Solo puedes editar los comentarios que has creado.'
      );
      return;
    }
    await this.commentService.editComment($event[0], () => {
      this.reloadComments.emit();
    });
  }

  onFileIconClick($event: string) {
    this.commentService.showAttachment($event, this.companyId);
  }

  private async deleteNotificationAndEmergencyActivity(
    urlNotification: string,
    idEmergyActivity: number
  ) {
    let resDeleteActividadEmergente: BaseResponse<GenericResponse> =
      await this.http.deleteDataPromise(
        `${this.urlActividadEmergente}/${idEmergyActivity}`
      );
    if (resDeleteActividadEmergente['code'] === 0) {
      this.notificationService.deleteNotificationByUrl(urlNotification);
    } else {
      this.message.Error('Error', resDeleteActividadEmergente['message']);
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos');
  }

  typeResponsible($event: string) {
    this.formStepeFour.controls.responsibleType.setValue($event);
    if (this.formStepeFour.controls.responsibleType.value == 'tercero') {
      this.recargarTablaTerceros.emit();
    } else {
      this.recargarTablaUsuarios.emit();
    }

    this.data.action != 'edit' ? this.stepper.next() : null;
  }

  remove(data: params) {
    const index = this.chipResponsable.indexOf(data);

    if (index >= 0) {
      this.chipResponsable.splice(index, 1);
    }
  }

  clickFilaTerceros($event: Provider) {
    for (let element of this.chipResponsable) {
      if (element.id == $event.id.toString()) {
        return false;
      }
    }
    this.chipResponsable.push({
      nombre: $event.providerName,
      id: $event.id.toString(),
    });
  }

  clickFilaUsuarios($event: User) {
    for (let element of this.chipResponsable) {
      if (element.id == $event.userId.toString()) {
        return false;
      }
    }
    this.chipResponsable.push({
      nombre: $event.name,
      id: $event.userId.toString(),
    });
  }

  async finalizar(print: boolean) {
    try {
      this.buttonEnd = true;

      if (this.registerMaintenance) {
        this.registerMaintenaceSendEvent(print);
        return;
      }

      this.message.openLoading('Cargando', 'Guardando Orden de trabajo');

      let workOrder = await this.getOtFromForm();
      const responsiblesIds = this.chipResponsable.map((item) =>
        Number(item.id)
      );
      workOrder = await this.saveOt(
        workOrder,
        responsiblesIds,
        this.equipo.code
      );
      await this.saveResources(workOrder);

      this.message.closeLoading();

      this.message.SuccessToast(`Orden de trabajo creada`);
      if (print) {
        await this.generatePdf.printTemplateOt(workOrder.id, true);
      }
      this.navigateEnd(workOrder);
    } catch (error) {
      this.message.Error('Error', 'Error creando orden de trabajo');
    }
    this.message.closeLoading();
  }

  async saveOt(
    workOrder: WorkOrder,
    responsiblesIds?: number[],
    equipmentCode?: string
  ): Promise<WorkOrder> {
    if (
      this.data.action == 'add' ||
      this.data.action == 'calendario' ||
      this.data.action == 'solicitud'
    ) {
      workOrder.responsiblesBody = {
        responsiblesIds,
        responsibleType: this.formStepeFour.controls.responsibleType.value,
        sendNotification: true,
        equipmentCode,
      };
      let workOrderId = await this.workOrderService.addWO(
        workOrder,
        this.formStepeTwo.controls.tipoMtto.value,
        this.actividad.body &&
          this.actividad.body[0] &&
          this.actividad.body[0].id
          ? this.actividad.body[0].id
          : 0
      );
      if (workOrderId > 0) {
        workOrder.id = workOrderId;
        if (this.data.action == 'solicitud') {
          this.deleteNotificationAndEmergencyActivity(
            `notificaciones/solicitudes?id_actividad_emergente=${this.data.body.id}`,
            this.data.body.id
          );
        }
        this.orderId = workOrderId;

        if (workOrder.authorized == 0) {
          await this.notificationService.sendNotificationAutorizeMaintenance(
            `Equipo:${this.equipo.code} / ${workOrder.description}`,
            this.orderId,
            workOrder.authorizesId
          );
          return workOrder;
        }

        if (workOrder.readyResources == 1) {
          await this.notificationService.sendNotificationMaintenance(
            `Equipo:${this.equipo.code} / ${workOrder.description}`,
            this.orderId,
            workOrder.responsibleId
          );
        }
      }
    } else {
      await this.workOrderService.updateWO(workOrder, this.data);
    }
    return workOrder;
  }

  async saveResources(workOrder: WorkOrder) {
    if (this.inventoryModule && this.resources && this.resources.length > 0) {
      await this.resourcesService.saveResources(
        this.resources,
        this.orderId,
        true
      );
      if (workOrder.authorized === 1)
        await this.notificationService.sendNotificationStorer(
          `Equipo:${this.equipo.code} / ${workOrder.description}`,
          this.orderId
        );
    }
  }

  async registerMaintenaceSendEvent(print: boolean) {
    this.registerMaintenanceEvent.emit({
      workOrder: await this.getOtFromForm(),
      resources: this.resources,
      responsible: this.chipResponsable,
      responsibleType: this.formStepeFour.controls.responsibleType.value,
      maintenanceType: this.formStepeTwo.controls.tipoMtto.value,
      activityId:
        this.actividad.body &&
        this.actividad.body[0] &&
        this.actividad.body[0].id
          ? this.actividad.body[0].id
          : 0,
      print,
    });
  }

  async navigateEnd(workOrder: WorkOrder) {
    if (workOrder.authorized == 1) {
      if (this.resources.length > 0) {
        setTimeout(() => {
          this.router.navigate(['/mantenimiento/despachar_recursos']);
        }, 500);
        return;
      }

      setTimeout(() => {
        this.router.navigate(['mantenimiento/ejecucion_OT']);
      }, 500);
    } else {
      setTimeout(() => {
        this.router.navigate(['mantenimiento/orden_trabajo']);
      }, 500);
    }
  }

  agregarUsuariosOrden($event: string) {
    this.dialog
      .open(ModalMaintenanceOrdersComponent, {
        width: `${this.size}%`,
        height: `${this.size}%`,
        data: {
          action: 'add',
          orderId: this.data.body[0].id,
          responsible: this.data.body.responsible,
        },
      })
      .afterClosed()
      .subscribe(() => {
        this.recargarTablaUsuariosOrden.emit();
        // if (this.formStepeFour.controls.responsibleType.value == 'tercero') {
        //   this.changeToggle({ source: null, checked: false } )
        // } else {
        //   this.changeToggle({ source: null, checked: true } )
        // }
      });
  }

  async eliminarUsuariosOrden($event: UserWO[]) {
    let res = await this.deleteItem.deleteD(
      $event,
      this.urlPostUsuariosOT,
      'id',
      'Encargado',
      'Encargados'
    );
    this.recargarTablaUsuariosOrden.emit();
  }

  userOrdersDataTable($event: Data<UserWO[]>) {
    this.bodyResponsable = $event.data;
  }

  back($event: PointerEvent) {
    $event.preventDefault();
    setTimeout(() => {
      this.location.back();
    }, 500);
  }

  selectedTabChange($event: StepperSelectionEvent) {
    if (
      this.inventoryModule &&
      this.comboItemLength > 0 &&
      $event.selectedIndex == 3
    )
      this.validateResoruces.controls.resorucesAdd.setValue(null);
  }

  async deleteOT($event: PointerEvent) {
    $event.preventDefault();
    let arrayDelete: Array<WorkOrder> = [];
    arrayDelete.push(this.data.body[0]);
    let res = await this.deleteItem.deleteD(
      arrayDelete,
      this.urlPostOT,
      'id',
      'Orden de Trabajo'
    );
    if (res) {
      this.notificationService.deleteNotificationByUrl(
        `notificaciones/autorizacion?id_orden_trabajo=${this.data.body[0].id}`
      );
      this.message.SuccessToast('Orden de Trabajo eliminada correctamente');
      this.location.back();
    }
  }

  async changeToggle($event: MatSlideToggleChange) {
    this.isChecked = $event.checked;

    if (this.bodyResponsable.length > 0) {
      if (this.bodyResponsable[0].responsibleType == 'tercero') {
        this.isChecked = false;
        this.data.body.responsible = 'tercero';
      } else {
        this.isChecked = true;
        this.data.body.responsible = 'usuario';
      }
    }

    if (this.isChecked == true) {
      this.labelToggle = 'Tabla Usuarios';
      this.formStepeFour.controls.responsibleType.setValue('usuario');
      this.data.body.responsible = 'usuario';
    } else {
      this.labelToggle = 'Tabla Terceros';
      this.formStepeFour.controls.responsibleType.setValue('tercero');
      this.data.body.responsible = 'tercero';
    }

    this.typeResponsibleView();
  }

  async print($event: PointerEvent, data) {
    $event.preventDefault();
    let res: boolean | unknown = await this.generatePdf.printTemplateOt(
      this.data.body[0].id
    );

    if (res) {
      setTimeout(() => {
        this.location.back();
      }, 500);
    }
  }
}
